<template>
    <div>
      <VueNextSelect
          :options="customers"
          v-model="selectedCustomer"
          :label-by="(x) => x.name+' ('+x.kdnr+')'"
          value-by="id"
          searchable
          clear-on-close
          close-on-select
          search-placeholder="Kunden auswählen"
          placeholder="Kunden auswählen"
          onchange="onCustomerSelect"
      />
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import VueNextSelect from 'vue-next-select';

  export default {
    props: ['transactionId', 'customers'],
    data() {
      return {
        selectedCustomer: null
      };
    },
    methods: {
      onCustomerSelect() {
        alert("Hi")
        // Handle customer selection logic
        // Send POST request with this.transactionId and this.selectedCustomer
      }
    }
  };
  </script>
  